import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer, View } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import enUS from "date-fns/locale/en-US";
import { useForm, FormProvider } from "react-hook-form";
// import "react-big-calendar/lib/css/react-big-calendar.css";
import "../css/react-big-calendar.css";

import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { useAuth } from "../lib/AuthContext";
import XanoAPI from "../lib/XanoAPI"; // Assuming XanoAPI is in this path
import { EngagementType } from "../types";

// Localizer for date-fns
const locales = { "en-US": enUS };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

interface EventType {}

const CalendarPage: React.FC = () => {
  const methods = useForm();
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [view, setView] = useState<View>("month");
  const [engagements, setEngagements] = useState<EngagementType[]>([]);
  const [events, setEvents] = useState<any[]>([]);

  const auth = useAuth();
  const flags = auth?.featureFlags || [];
  const isAllowed = (flag: string) => flags.includes(flag);

  // Fetch engagements from Xano API
  useEffect(() => {
    const fetchEngagements = async () => {
      try {
        const api = XanoAPI.getInstance();
        const fetchedEngagements = await api.getEngagements();
        const formattedEngagements = fetchedEngagements.map(
          (engagement: any) => ({
            title: engagement.description,
            start: new Date(engagement.start_date),
            end: new Date(engagement.end_date),
          })
        );
        setEvents(formattedEngagements);
      } catch (error) {
        console.error("Error fetching engagements:", error);
      }
    };

    fetchEngagements();
  }, []);

  return (
    <div className="hidden flex-col md:flex w-full calendar-dashboard">
      <Header />
      <FormProvider {...methods}>
        <div className="flex-1 space-y-0 p-8 pt-6 container flex flex-col mt-10 w-full">
          <div className="border border-gray-300 rounded-lg bg-white dark:bg-gray-900 p-4 mt-6 font-normal text-sm text-slate-600">
            <Calendar
              localizer={localizer}
              events={events} // Use fetched engagements
              startAccessor="start"
              endAccessor="end"
              date={selectedMonth}
              onNavigate={(date: any) => setSelectedMonth(date)}
              view={view}
              onView={(newView: any) => setView(newView)}
              style={{
                height: 600,
              }}
            />
          </div>
        </div>
      </FormProvider>

      {/* Footer */}
      <div className="footer-section">
        <Footer />
      </div>
    </div>
  );
};

export default CalendarPage;
